import { inject, Injectable } from '@angular/core'
import { LayoutService } from './ui/layout.service'
import Swal, { SweetAlertIcon, SweetAlertOptions, SweetAlertResult } from 'sweetalert2'

@Injectable({
	providedIn: 'root',
})
export class SwalService {
	readonly #layoutService = inject(LayoutService)

	public fire(title?: string, html?: string, icon?: SweetAlertIcon): Promise<SweetAlertResult>
	public fire(options: SweetAlertOptions): Promise<SweetAlertResult>
	public fire(
		optionsOrTitle?: SweetAlertOptions | string,
		html?: string,
		icon?: SweetAlertIcon
	): Promise<SweetAlertResult> {
		const isOptions = typeof optionsOrTitle === 'object' && optionsOrTitle !== null
		const isDark = this.#layoutService.isDarkTheme()

		if (isOptions) {
			return Swal.fire({
				background: isDark ? '#2d2d2d' : '#fff',
				color: isDark ? '#fff' : '#000',
				...optionsOrTitle,
			} as SweetAlertOptions)
		}

		return Swal.fire({
			title: optionsOrTitle,
			html,
			icon,
			background: isDark ? '#2d2d2d' : '#fff',
			color: isDark ? '#fff' : '#000',
		} as SweetAlertOptions)
	}
}
